// import { lazy } from 'react';   // only needed by the commented-out landing page
import { createBrowserRouter, Navigate } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PublicRoutes from './PublicRoutes';

//import ComponentsRoutes from './ComponentsRoutes';

// Used by the commented-out landing-page route below.
// import { SimpleLayoutType } from 'config';
// import SimpleLayout from 'layout/Simple';
// import Loadable from 'components/Loadable';

// render - landing page
//const PagesLanding = Loadable(lazy(() => import('pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Navigate to="/accounts/search" replace />
      //element: <SimpleLayout layout={SimpleLayoutType.LANDING} />,
      //children: [
      //  {
      //    index: true,
      //    element: <PagesLanding />
      //  }
      //]
    },
    PublicRoutes,
    LoginRoutes,
    //ComponentsRoutes,
    MainRoutes,
    // Catch-all: any unknown path (e.g. the removed /register) lands on the
    // login page instead of react-router's raw 404 error screen. GuestGuard
    // bounces already-logged-in users on to APP_DEFAULT_PATH from there.
    { path: '*', element: <Navigate to="/login" replace /> }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
